import { Box } from '../../Box/Box';
import { pillStyle } from './SegmentedProgress.css';

export interface SegmentedProgressProps {
  numSteps: number;
  step: number;
}

export const SegmentedProgress = ({ numSteps, step }: SegmentedProgressProps): JSX.Element => {
  const arrayOfSteps = new Array(numSteps).fill(null).map((element, i) => {
    const status = i + 1 < step ? 'previous' : i + 1 > step ? 'next' : 'current';

    return <span key={`Step number ${i + 1}`} className={pillStyle({ status })}></span>;
  });

  return (
    <Box display="flex" flexDirection="row" gap="xxsmall">
      {arrayOfSteps}
    </Box>
  );
};
